export default class ResetZoomControl {
    _container;

    onAdd(map) {
        this._map = map;
        this._container = document.createElement('div');
        this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
        this._container.addEventListener('contextmenu', e => e.preventDefault());

        // eslint-disable-next-line no-unused-vars
        this._container.addEventListener('click', e => {
            this._map.zoomTo(3);
        });

        this._container.innerHTML = `
            <div class="mapboxgl-ctrl-reset-zoom">
               <button>
                  <span class="mapboxgl-ctrl-icon my-image-button" aria-hidden="true" title="Description"></span>
               </button>
            </div>`;

        return this._container;
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this.map = undefined;
    }
}
